import React from "react";
import { Add } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import WorkflowCanvasIcon from "./WorkflowCanvasIcon";
import { WORKFLOW_CANVAS_TYPES, WorkflowCanvasType } from "./workflowBuilderData";

interface WorkflowCanvasPaletteProps {
  onAdd: (type: WorkflowCanvasType) => void;
}

const WorkflowCanvasPalette: React.FC<WorkflowCanvasPaletteProps> = ({ onAdd }) => {
  const handleAdd = (event: React.MouseEvent<HTMLButtonElement>) => {
    onAdd(event.currentTarget.dataset.canvasType as WorkflowCanvasType);
  };

  return (
    <aside className="workflow-builder__palette" aria-labelledby="canvas-palette-title">
      <Typography id="canvas-palette-title" className="workflow-builder__side-title">
        <Add fontSize="small" />
        Canvas palette
      </Typography>
      <Typography className="workflow-builder__palette-help">
        Add a canvas to the flow, then open it to configure its details.
      </Typography>

      <Box className="workflow-builder__palette-list">
        {WORKFLOW_CANVAS_TYPES.map((item) => (
          <Button
            key={item.type}
            className="workflow-builder__palette-item"
            data-canvas-type={item.type}
            onClick={handleAdd}
          >
            <span
              className={`workflow-builder__canvas-icon workflow-builder__canvas-icon--${item.type}`}
            >
              <WorkflowCanvasIcon type={item.type} />
            </span>
            <span className="workflow-builder__palette-copy">
              <strong>{item.label}</strong>
              <span>{item.description}</span>
            </span>
          </Button>
        ))}
      </Box>
    </aside>
  );
};

export default WorkflowCanvasPalette;
